import React from "react";
import { Link } from "react-router-dom";

const ContactsPage = () => {
  return (
    <div className="info-page">
      <div className="info-page-header">
        <Link to="/" className="back-button">
          ✕
        </Link>

        <h1>Контакты ☎️</h1>
      </div>

      <div className="info-card">
        <div className="info-section">
          <h2 className="info-section-title">Бильярдный клуб The Feel's 🩷</h2>

          <p className="info-section-text">Мы вызываем чувства!</p>
        </div>

        <div className="info-address-box">
          <div className="info-section">
            <h3 className="info-section-title">Адрес 📍</h3>

            <p className="info-section-text">
              Пер. Гривцова д. 1/64В
              <br />
              (Находимся во дворе, стройте маршрут по Яндекс.Навигатору
              <br />
              Вход в арку с переулка Гривцова. Справа от ворот наш звоночек 🔔
            </p>
          </div>
        </div>

        <div className="info-section">
          <h3 className="info-section-title">По вопросам, не связанным с бронью, пишите, или звоните:</h3>

          <div className="contacts-buttons">
            <a
              href="https://t.me/trueavanture"
              target="_blank"
              rel="noreferrer"
              className="contact-action-button"
            >
              @trueavanture 💌
            </a>

            <a href="tel:+79119901993" className="contact-action-button">
              +7 (911) 990-19-93
            </a>
          </div>
        </div>

        <div className="info-section">
          <h3 className="info-section-title">Соцсети 🫶</h3>

          <div className="contacts-buttons">
            <a
              href="https://t.me/thefeels_billiard"
              target="_blank"
              rel="noreferrer"
              className="contact-action-button"
            >
              Telegram канал
            </a>

            <a
              href="https://www.instagram.com/thefeels_billiard"
              target="_blank"
              rel="noreferrer"
              className="contact-action-button"
            >
              Какая-то соц. сеть с фотками 📸
            </a>
          </div>
					<p className="info-section-text" style={{textAlign: "center"}}>Подпишись, Бро! 🫶</p>
        </div>
      </div>
    </div>
  );
};

export default ContactsPage;
